import React from 'react';
import Layout from '../containers/Layout';

export const PrivateRoute = ({ component, modules, ...rest }) => {
  // const { token_type } =
  //   JSON.parse(sessionStorage.getItem('pharmaforce')) || {};

   return <Layout modules={modules} />;
};
